module.exports = __webpack_public_path__ + "img/360-utomhus-framsida.661ed1e5.jpg";